module.exports = __webpack_public_path__ + "img/fk4151_center_002.64e5e576.png";